const defaultState = {
  isLoaded: true,
  isLoadedSubjects: false,
  subjects: [],
  categories: [],
  sources: [],
  subcategories: [],
  selectSubject: null,
  selectSource: null,
  selectCategory: null,
  selectSubcategory: null,
  list: [],
  checkCategories: [],
  checkSubcategories: [],
  isShowModal: false,
  isTrashed: false,
  item: {}
}

const flashcard = (state = defaultState, action) => {
  switch (action.type) {
    case 'CREATE_FLASHCARD':
      return {
        ...state,
        list: 
          (
            state.checkCategories.includes(action.data.category_id) 
            || state.checkSubcategories.includes(action.data.category_id)
          ) ? [...state.list, action.data] : state.list,
        isLoaded: true
      }
    case 'UPDATE_FLASHCARD':
      return {
        ...state,
        list: 
          (state.isTrashed 
            || state.checkCategories.includes(action.data.category_id) 
            || state.checkSubcategories.includes(action.data.category_id) 
          ) ? state.list.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}) : state.list.filter(_i => _i.id != action.data.id),
        isLoaded: true
      }
    case 'DELETE_FLASHCARD':
      return {
        ...state,
        list: state.list.filter(_i => _i.id != action.data),
        isLoaded: true
      }
    case 'SET_FLASHCARDS':
      return {
        ...state,
        list: action.data,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SUBJECTS':
      return {
        ...state,
        subjects: action.data,
        isLoadedSubjects: true,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SOURCES':
      return {
        ...state,
        sources: action.data,
        isLoadedSubjects: true,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SUBJECTS_ADD':
      return {
        ...state,
        subjects: [...state.subjects, action.data],
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SOURCES_ADD':
      return {
        ...state,
        sources: [...state.sources, action.data],
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SOURCES_UP':
      return {
        ...state,
        sources: state.sources.map(_i => action.data.id == _i.id ? {...action.data} : {..._i}, ),
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SUBJECTS_UP':
      return {
        ...state,
        subjects: state.subjects.map(_i => action.data.id == _i.id ? {...action.data} : {..._i}, ),
        isLoaded: true
      };
    case 'SET_FLASHCARDS_CATEGORY_UPDATE':
      return {
        ...state,
        categories: !action.data.parent_id ? state.categories.map(_i => _i.id == action.data.id ? {..._i, ...action.data} : {..._i}, ) : state.categories,
        subcategories: action.data.parent_id ? state.subcategories.map(_i => _i.id == action.data.id ? {..._i, ...action.data} : {..._i}, ) : state.subcategories,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_CATEGORY_ADD':
      return {
        ...state,
        categories: !action.data.parent_id ? [...state.categories, action.data] : state.categories,
        subcategories: action.data.parent_id ? [...state.subcategories, action.data] : state.subcategories,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SUBJECTS_DELETE':
      return {
        ...state,
        subjects: state.subjects.filter(_i => _i.id != action.data),
        categories: [],
        selectSubject: null,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SOURCES_DELETE':
      return {
        ...state,
        sources: state.sources.filter(_i => _i.id != action.data),
        selectSource: null,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_CATEGORY_DELETE':
      return {
        ...state,
        categories: state.categories.filter(_i => _i.id != action.data),
        selectCategory: null,
        list: state.list.filter(_i => _i.category_id != action.data),
        checkCategories: state.checkCategories.filter(_i => _i != action.data),
        isLoaded: true
      };
    case 'SET_FLASHCARDS_SUBCATEGORY_DELETE':
      return {
        ...state,
        subcategories: state.subcategories.filter(_i => _i.id != action.data),
        list: state.list.filter(_i => _i.subcategory_id != action.data),
        checkSubcategories: state.checkSubcategories.filter(_i => _i != action.data),
        selectSubcategory: null,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_CATEGORIES':
      return {
        ...state,
        categories: action.data,
        subcategories: action.subcategories,
        isLoadedCategories: true,
        isLoaded: true
      };
    case 'SET_FLASHCARDS_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    default:
      return state
  }
}

export default flashcard;
